import { FULL_SERVICE, GLOBAL_CATALOGS, HAS_DETAILS } from '../../types';
import { queryAllContentList, queryContentList } from '../cmsAction';


// 勞工安全衛生管理
export const queryLauanSafetyManagementList = (list) => async (dispatch, getState) => {
  dispatch({
    type: GLOBAL_CATALOGS.Lauan.Root,
    payload: list
  });
};

/* ********************************************************************************************************* */
/* ********************************************************************************************************* */


export const onChangeLaborCategory = (item) => (dispatch, getState) => {
  dispatch(queryLauanList(item));

  dispatch({
    type: FULL_SERVICE.Labor.Value,
    payload: item?.contentCode
  });
};

// 勞安首頁數據
export const queryLauanList = (item) => async (dispatch, getState) => {
  const data = await dispatch(queryAllContentList({ contentCode: item?.contentCode, page: 1, rowsPerPage: 3 }));
  dispatch({
    type: FULL_SERVICE.Labor.List,
    payload: {
      title: item?.label,
      path: item?.props?.path,
      list: data?.list,
      total: data?.total,
      page: data?.page,
      rowsPerPage: data?.rowsPerPage,
      pages: data?.pages,
    }
  });
};



// 職安政策
export const queryLauanPolicyList = ({ page = 1, rowsPerPage = 10, ruleTag = '' }) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_SERVICE.Labor.Loading,
    payload: true
  });
  
  const response = await dispatch(queryContentList({ contentCode: GLOBAL_CATALOGS.Labor.Policy.Report, page, rowsPerPage, ruleTag, hasDetails: HAS_DETAILS.True }));
  dispatch({
    type: GLOBAL_CATALOGS.Labor.Policy.Report,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_SERVICE.Labor.Loading,
      payload: false
    });
  }, 260);
};

// 職安快訊
export const queryLauanNewsList = ({ page = 1, rowsPerPage = 10, ruleTag = '' }) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_SERVICE.Labor.Loading,
    payload: true
  });
  
  const response = await dispatch(queryContentList({ contentCode: GLOBAL_CATALOGS.Labor.News.List, page, rowsPerPage, ruleTag, hasDetails: HAS_DETAILS.True }));
  dispatch({
    type: GLOBAL_CATALOGS.Labor.News.List,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_SERVICE.Labor.Loading,
      payload: false
    });
  }, 260);
};



// 檢測報告-Value
export const onChangeReportTabsItem = (value, title) => async (dispatch, getState) => {
  const { service: { labor: { test }  } } = getState();
  await dispatch({
    type: FULL_SERVICE.Labor.Test.Value,
    payload: value
  });
  await dispatch(queryLauanTestList({ contentCode: value }))
};

// 檢測報告
export const queryLauanTestList = ({ contentCode, ruleTag = '', page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_SERVICE.Labor.Loading,
    payload: true
  });
  
  const response = await dispatch(queryContentList({ contentCode, hasDetails: HAS_DETAILS.True, ruleTag, page, rowsPerPage }));
  dispatch({
    type: GLOBAL_CATALOGS.Labor.Test.Report,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_SERVICE.Labor.Loading,
      payload: false
    });
  }, 260);
};

// 勞安服務-常見問題
export const queryLauanFaqsList = ({ ruleTag = '', page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_SERVICE.Labor.Loading,
    payload: true
  });
  
  const response = await dispatch(queryContentList({ contentCode: GLOBAL_CATALOGS.Labor.FAQS.List, hasDetails: HAS_DETAILS.True, ruleTag, page, rowsPerPage, }));
  dispatch({
    type: GLOBAL_CATALOGS.Labor.FAQS.List,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_SERVICE.Labor.Loading,
      payload: false
    });
  }, 260);
};
